// @ vendor
const Immutable = require('immutable');

// @ utilities
const IbanHelper = require('utilities/ibanHelper');
const { generateAccountId } = require('utilities/APIParsingHelper');

// @ constants
const { PAYMENT_TYPE, FLOW_STEPS } = require('../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_REQUEST_RELATED_WIZARD_LOAD_STEP,
    INSURANCE_REQUEST_RELATED_WIZARD_VALIDATE_STEP,
    INSURANCE_REQUEST_RELATED_WIZARD_SET_VISIBLE_STEP,
    INSURANCE_REQUEST_RELATED_WIZARD_SET_DATA,
    INSURANCE_REQUEST_RELATED_PRICING_REQUEST,
    INSURANCE_REQUEST_RELATED_PRICING_SUCCESS,
    INSURANCE_REQUEST_RELATED_PRICING_FAILURE,
    INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_REQUEST,
    INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_SUCCESS,
    INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_FAILURE,
    INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_REQUEST,
    INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_SUCCESS,
    INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_FAILURE,
    INSURANCE_REQUEST_RELATED_SAVE_STEP_REQUEST,
    INSURANCE_REQUEST_RELATED_SAVE_STEP_SUCCESS,
    INSURANCE_REQUEST_RELATED_SAVE_STEP_FAILURE
} = require('../../insuranceConstants/actionTypes');

const setInitialState = () => {
    return Immutable.Map().merge({
        valid: false,
        validUI: false,
        fieldErrors: false,
        paymentType: '',
        startDate: '',
        hasMortgage: false,
        mortgageBank: '',
        accountId: null,
        totalCost: null,
        accountBalance: 0,
        enoughAccountBalance: false,
        accountIBAN: null,
        setPaymentAccountInProgress: false,
        isFetchingAccount: false,
        isSaving: false,
        road: '',
        number: '',
        additionalInfo: '',
        pricing: {},
        isFetchingPricing: false,
        errorPricing: '',
        errorSave: '',
        errorPayment: '',
        accountIdIsBlocked: false,
    });
};

const validateStep = step => {
    const accountId = step.get('accountId');
    const isFetchingPricing = step.get('isFetchingPricing');
    const validUI = !isFetchingPricing && !!accountId && !step.get('accountIdIsBlocked');

    return step.merge({
        validUI,
        fieldErrors: true
    });
};

const insuranceRequestRelatedWizardStep4 = (state = setInitialState(), action) => {
    switch (action.type) {
        case INSURANCE_REQUEST_RELATED_WIZARD_VALIDATE_STEP:
            return validateStep(state);

        case INSURANCE_REQUEST_RELATED_WIZARD_LOAD_STEP:
            const {
                payment: { paymentType },
                flowData: { uiStep },
                home: { population }
            } = action.data;

            return state.merge({
                paymentType: state.get('paymentType') || paymentType || PAYMENT_TYPE.ANNUAL,
                valid: FLOW_STEPS[uiStep] > FLOW_STEPS.STEP_4,
                population,
            });

        case INSURANCE_REQUEST_RELATED_WIZARD_SET_VISIBLE_STEP:
            return state.merge({
                valid: false,
                fieldErrors: false
            });

        case INSURANCE_REQUEST_RELATED_WIZARD_SET_DATA:
            return state.merge({
                ...action.data,
                validUI: false,
                valid: false
            });

        case INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_REQUEST:
            return state.merge({
                isFetchingAccount: true,
                errorPayment: ''
            });

        case INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_SUCCESS:
            let accountId = state.get('accountId');
            let accountIBAN = state.get('accountIBAN');

            if (action.data && action.data.account) {
                accountIBAN = action.data.account;
                const ibanComplex = IbanHelper.getIbanComplexObject(accountIBAN);
                accountId = generateAccountId({
                    country: ibanComplex.pais,
                    controlDigit: ibanComplex.digitodecontrol,
                    codbban: ibanComplex.codbban
                });
            }
            return state.merge({
                accountId,
                accountIBAN,
                isFetchingAccount: false
            });

        case INSURANCE_REQUEST_RELATED_GET_PAYMENT_ACCOUNT_FAILURE:
            return state.merge({
                isFetchingAccount: false,
                errorPayment: action.data.error
            });

        case INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_REQUEST:
            return state.merge({
                setPaymentAccountInProgress: true,
                errorPayment: ''
            });

        case INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_SUCCESS:
            return state.merge({
                setPaymentAccountInProgress: false
            });
        case INSURANCE_REQUEST_RELATED_SET_PAYMENT_ACCOUNT_FAILURE:
            return state.merge({
                setPaymentAccountInProgress: false,
                errorPayment: action.data.error
            });

        case INSURANCE_REQUEST_RELATED_PRICING_REQUEST:
            return state.merge({
                isFetchingPricing: true,
                fieldErrors: false,
                errorPricing: ''
            });

        case INSURANCE_REQUEST_RELATED_PRICING_SUCCESS:
            return state.mergeDeep({
                pricing: action.data,
                isFetchingPricing: false
            });

        case INSURANCE_REQUEST_RELATED_PRICING_FAILURE:
            return state.merge({
                errorPricing: action.data.error,
                isFetchingPricing: false
            });

        case INSURANCE_REQUEST_RELATED_SAVE_STEP_REQUEST:
            return state.merge({
                isSaving: true,
                errorSave: ''
            });
        case INSURANCE_REQUEST_RELATED_SAVE_STEP_SUCCESS:
            return state.merge({
                isSaving: false,
                valid: true
            });
        case INSURANCE_REQUEST_RELATED_SAVE_STEP_FAILURE:
            return state.merge({
                isSaving: false,
                errorSave: action.data.error
            });

        default:
            return state;
    }
};

module.exports = insuranceRequestRelatedWizardStep4;
